import CryptoJS from 'crypto-js'
const crypto = {
  _KEY: '12345678900000001234567890000000',
  _IV: '1234567890000000',
  Encrypt: function (str, key) {
    key = CryptoJS.enc.Utf8.parse(key || this._KEY)
    var iv = CryptoJS.enc.Utf8.parse(this._IV)

    var encrypted = ''

    var src = CryptoJS.enc.Utf8.parse(str)
    encrypted = CryptoJS.AES.encrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    // return encrypted.ciphertext.toString()
    return encrypted.toString()
  },
  Decrypt: function (str, key) {
    key = CryptoJS.enc.Utf8.parse(key || this._KEY)
    var iv = CryptoJS.enc.Utf8.parse(this._IV)
    var encryptedHexStr = CryptoJS.enc.Hex.parse(str)
    var src = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    var decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  }
}

export default crypto



// WEBPACK FOOTER //
// ./src/utils/crypto.js